import $ from "jquery";

$(document).ajaxComplete(resizeSizeBar);
$(document).ready(resizeSizeBar);
$(window).resize(resizeSizeBar);

function resizeSizeBar() {
    const sideBar = $('.help-system__sidebar');
    const wrapper = $('.help-system__sidebar-wrapper');

    if (sideBar.length === 0) {
        return;
    }

    const content = $('.help-system__content');
    const inner = $('.help-system__content-inner');
    const header = $('.help-shift-nav');
    const footer = content.find('.footer');

    sideBar.css('height', '');
    wrapper.css('height', '');

    const barHeight = window.innerHeight - (parseInt(header.css('margin-top')) + header.height());
    const footerHeight = footer.height() + parseInt(footer.css('margin-top'))
    const contentPadding = parseInt(content.css('padding-top')) + parseInt(content.css('padding-bottom'));
    const innerHeight = barHeight - contentPadding - footerHeight;

    sideBar.css('height', barHeight);
    wrapper.css('height', barHeight);
    inner.css('min-height', innerHeight);
}
